import React, { useState } from 'react';
import  '../sections/Education.css';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import Image from '../elements/Image';
import * as data from '../../Lokesh_Profile.json'
import { FaFacebookF,FaGithubAlt,FaLinkedinIn,FaMediumM,FaFileAlt,FaInstagram } from "react-icons/fa";
const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

const about = data.about

const About = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {

  const [videoModalActive, setVideomodalactive] = useState(false);

  const openModal = (e) => {
    e.preventDefault();
    setVideomodalactive(true);
  }

  const closeModal = (e) => {
    e.preventDefault();
    setVideomodalactive(false);
  }   

  const outerClasses = classNames(
    'hero section center-content',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'hero-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );



  return (
    <section class="ftco-section about-section">
    <div class="container">
      <div class="row d-flex" data-scrollax-parent="true">
        <div class="col-md-5 author-img"
                  data-scrollax=" properties: { translateY: '-70%'}">
             <Image
             className='author-img'
             height='100%'
            //  style={{display:'block'}}
             width='100%'
                  src={about[0].photoURL}
                  alt="Features split 01"
 />
            {/* <p style={{color:"#fff", fontSize: "12px", marginTop:"8px", letterSpacing: "2px"}}><span class="icon-add_location"></span> SAN FRANCISCO, CALIFORNIA</p> */}
            </div>
        <div class="col-md-1"></div>
        <div class="col-md-6 wrap  fadeInUp ">
          <div class="about-desc">
            <h1 class="bold-text reveal-from-bottom"  data-reveal-delay="200">About</h1>
            <div class="p-5">
              <h2 class="mb-5 reveal-from-bottom"  data-reveal-delay="300" style={{marginBottom:'20px !important'}}>Hi! I'm {about[0].shortname}</h2>
              <p className="reveal-from-bottom"  data-reveal-delay="400">{about[0].about}
              </p>
              
              <ul class="ftco-footer-social list-unstyled mt-4 reveal-from-bottom"  data-reveal-delay="400">
                <li><a href={about[0].resume} target="_blank"><span class="icon-file"><FaFileAlt /></span></a>
                </li>   
                <li><a target="_blank" href={about[0].github}><span class="icon-github"><FaGithubAlt /></span></a></li>
                  <li><a target="_blank" href={about[0].medium}><span class="icon-medium"><FaMediumM /></span></a></li>

                  <li><a target="_blank" href={about[0].linkedin}><span class="icon-linkedin"><FaLinkedinIn /></span></a></li>
                <li>
                  
                  <a target="_blank" href={about[0].facebook}><span ><FaFacebookF /></span></a></li>
                <li><a target="_blank" href={about[0].instagram}><span class="icon-instagram"><FaInstagram /></span></a></li>
                
              </ul>
              {/* <h5>Contact me here!</h5>
              <p>Email: <a href="mailto:lokeshkumar824@gmail.com">{about[0].email}</a></p>
              <p>Phone: <a href="#">{about[0].phone}</a></p> */}
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </section>
  );
}

export default About;